




































import { Component, Vue, Prop } from "vue-property-decorator";
import { SchedulingModule } from "@/store/modules/SchedulingModule";
import MenuIconWithSelectionListComponent from "@/components/common/StateButtonWithSelectionList.vue";

import { TaskState } from "@/data/models/TaskState";
import {
  TaskSortOrder,
  localizeTaskSortOrder,
} from "@/data/models/TaskSortOrder";
import { TaskFilter } from "@/data/models/TaskFilter";

@Component({
  components: {
    "menu-icon": MenuIconWithSelectionListComponent,
  },
})
export default class TaskListHeaderComponent extends Vue {
  @Prop()
  taskState!: TaskState;

  filterFontSize = "0.9em";
  iconResourceSortOption = "mdi-sort-alphabetical-variant";
  iconResourceFilter = "mdi-filter-variant";

  get filterTooltip() {
    return `${this.$t("common.filter")}: ${this.getTaskFilterName(
      this.selectedFilter
    )} `;
  }

  get sortOrderTooltip() {
    return `${this.$t("common.sort")}: ${this.getSortOrderName(
      this.selectedSortOrder
    )} `;
  }

  get filters() {
    return this.taskState == TaskState.CONFIRMED
      ? [TaskFilter.LAST_WEEK, TaskFilter.STARTING_FROM_TODAY, TaskFilter.ALL]
      : [TaskFilter.LAST_WEEK, TaskFilter.LAST_FOUR_WEEKS, TaskFilter.ALL];
  }

  get sortOrders(): TaskSortOrder[] {
    return this.taskState == TaskState.CONFIRMED
      ? [
          TaskSortOrder.APPOINTMENT_DATE,
          TaskSortOrder.TASK_TYPE,
          TaskSortOrder.USER,
          TaskSortOrder.PROJECT_NUMBER,
        ]
      : [
          TaskSortOrder.EARLIEST_START_DATE,
          TaskSortOrder.TASK_TYPE,
          TaskSortOrder.PROJECT_NUMBER,
        ];
  }

  get title() {
    return this.taskState == TaskState.CONFIRMED
      ? this.$t("scheduling.tasks.confirmedTasks")
      : this.$t("scheduling.tasks.openTasks");
  }

  get selectedSortOrder() {
    return this.taskState == TaskState.CONFIRMED
      ? SchedulingModule.confirmedTasksSortOrder
      : SchedulingModule.openTasksSortOrder;
  }

  set selectedSortOrder(taskSortOrder: TaskSortOrder) {
    this.taskState == TaskState.CONFIRMED
      ? SchedulingModule.setConfirmedTasksSortOrder(taskSortOrder)
      : SchedulingModule.setOpenTasksSortOrder(taskSortOrder);
  }

  get selectedFilter() {
    return this.taskState == TaskState.CONFIRMED
      ? SchedulingModule.confirmedTasksFilter
      : SchedulingModule.openTasksFilter;
  }

  set selectedFilter(taskFilter: TaskFilter) {
    this.taskState == TaskState.CONFIRMED
      ? SchedulingModule.setConfirmedTasksFilter(taskFilter)
      : SchedulingModule.setOpenTasksFilter(taskFilter);
  }

  getSortOrderName(sortOrder: TaskSortOrder) {
    return localizeTaskSortOrder(this, sortOrder);
  }

  getTaskFilterShorthand(taskFilter: TaskFilter) {
    if (this.taskState == TaskState.CONFIRMED) {
      if (taskFilter == TaskFilter.LAST_WEEK) {
        return "-1";
      }

      if (taskFilter == TaskFilter.STARTING_FROM_TODAY) {
        return "0";
      }
    } else {
      if (taskFilter == TaskFilter.LAST_WEEK) {
        return "-1";
      }

      if (taskFilter == TaskFilter.LAST_FOUR_WEEKS) {
        return "-4";
      }
    }

    return "";
  }

  getTaskFilterName(taskFilter: TaskFilter) {
    const prefix = "scheduling.tasks.filter";

    if (this.taskState == TaskState.CONFIRMED) {
      if (taskFilter == TaskFilter.LAST_WEEK) {
        return this.$t(`${prefix}.startingFromLastWeek`);
      }

      if (taskFilter == TaskFilter.STARTING_FROM_TODAY) {
        return this.$t(`${prefix}.startingFromToday`);
      }
    } else {
      if (taskFilter == TaskFilter.LAST_WEEK) {
        return this.$t(`${prefix}.lastWeek`);
      }

      if (taskFilter == TaskFilter.LAST_FOUR_WEEKS) {
        return this.$t(`${prefix}.lastFourWeek`);
      }
    }

    return this.$t(`${prefix}.all`);
  }
}
